import { useMemo } from "react";

import { checkFeatureFlagGate, featureFlags } from "@/utils/feature-flags";

export const useJfindSimplifiedListViewWithBasicTasksUpdateTargetingGateEnabled =
    () => {
        return useMemo(() => {
            return checkFeatureFlagGate(
                featureFlags.jfindSimplifiedListViewWithBasicTasksGate2
            );
        }, []);
    };
